import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import cx from "classnames";
import { toolkitTestIds } from "../../../constants";
/**
 * A collapsible component that renders its children only when open.
 *
 * @component
 *
 * @param {ICollapsibleProps} props The component props.
 * @param {ReactNode} props.children The content to be displayed inside the collapsible.
 * @param {boolean} props.open Whether the collapsible is open or closed.
 * @param {ReactNode} props.trigger The content that triggers the opening and closing of the collapsible.
 * @param {IPrimitiveProps} [props.primitiveProps] The props to apply to the collapsible content.
 * @param {CollapsiblePrimitive.CollapsibleContentProps} [props.primitiveProps.content] The props to apply to the collapsible content.
 * @param {string} [props.className] The CSS class to apply to the component.
 * @param {string} [props.id] The ID to apply to the component.
 * @param {boolean} [props.disabled] Whether the collapsible is disabled or not.
 * @param {string} [props.testId="collapsible-container"] The test ID to apply to the component.
 * @param {function} [props.onOpenChange] A callback function that is fired when the collapsible opens or closes.
 *
 * @returns {JSX.Element} The rendered `Collapsible` component.
 */
const Collapsible = ({ children, trigger, primitiveProps, testId = toolkitTestIds.collapsible.content, ...props }) => {
    return (_jsxs(CollapsiblePrimitive.Root, { ...props, children: [trigger, _jsx(CollapsiblePrimitive.Content, { ...primitiveProps?.content, className: cx("overflow-hidden", "motion-safe:radix-state-closed:animate-collapsible-close motion-safe:radix-state-open:animate-collapsible-open", primitiveProps?.content?.className), "data-testid": testId, children: children })] }));
};
export default Collapsible;
//# sourceMappingURL=Collapsible.js.map